import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLanguage();
  return <footer className="px-5 pb-8 sm:px-6" data-id="element-78" data-mp="3gg0xbxz0nnv0">
      <p className="mx-auto max-w-[1080px] text-center text-[13px] text-grey-800-lock" data-id="element-79" data-mp="32nulgo2wc31d">
        {t.footer.text}
      </p>
    </footer>;
}